const getSetDate = () => {
  return new Date();
};

export default getSetDate;
